import React, { useMemo } from 'react';
import { ApiClient } from './ApiClient';
import { apiClientContext } from './apiClientContext';
export var ApiClientProvider = function (_a) {
    var camelcaseKeysOptions = _a.camelcaseKeysOptions, children = _a.children, baseUrl = _a.baseUrl, language = _a.language, tenant = _a.tenant, token = _a.token, timeout = _a.timeout;
    var apiClient = useMemo(function () {
        return new ApiClient({
            baseUrl: baseUrl,
            camelcaseKeysOptions: camelcaseKeysOptions,
            language: language,
            tenant: tenant,
            token: token,
            timeout: timeout,
        });
    }, [baseUrl, camelcaseKeysOptions, language, tenant, timeout, token]);
    return React.createElement(apiClientContext.Provider, { value: apiClient }, children);
};

//# sourceMappingURL=ApiClientProvider.js.map
